import type { ProjectVendorReviewEligibility } from "@shared/types";
import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/query-keys";
import { getProjectVendorReviewEligibility } from "@/services/reviews-api.service";

/**
 * The vendors the project's designer, homeowner or assigned contractor may
 * rate: those with a BOQ line the homeowner has approved, plus any already
 * rated. `enabled` should be true only for those three; the server refuses
 * everyone else.
 */
export function useProjectVendorReviewEligibility(
	projectId: string,
	enabled: boolean,
) {
	return useQuery<ProjectVendorReviewEligibility>({
		queryKey: queryKeys.reviews.projectVendorEligibility(projectId),
		enabled,
		queryFn: async () => {
			const result = await getProjectVendorReviewEligibility(projectId);
			if (!result.success || !result.data) {
				throw new Error(result.error ?? "Failed to load vendors to rate");
			}
			return result.data;
		},
	});
}
